import { useEffect, useRef, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Link, useLocation } from "react-router-dom";
import GridIcon from "../../../../assets/icons/GridIcon";
import useUser from "../../../../hooks/useUser";
import { getPermittedModules } from "../../ModuleNavigation/modules";

const SlideoutComponent = () => {
  const ref = useRef(null);
  const location = useLocation();
  const [gridStatus, changeGridStatus] = useState(false);
  const { hasPermission } = useUser();

  const handleGridStatus = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      changeGridStatus(false);
    }
  };

  useEffect(() => {
    changeGridStatus(false);
    document.addEventListener("click", handleGridStatus);
    return () => {
      document.removeEventListener("click", handleGridStatus);
    };
  }, [location.pathname]);

  const isCurrentModule = ({ pathname: modulePath }) =>
    location.pathname.startsWith(modulePath);
  const permittedModules = getPermittedModules(hasPermission);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => changeGridStatus(!gridStatus)}
        aria-label={gridStatus ? "Close modules" : "Open modules"}
        aria-expanded={gridStatus}
        className="group flex items-center justify-center rounded-full p-1 text-gray-700 shadow-[inset_0_0_0_2px_rgb(55,65,81)] hover:text-gray-500 hover:shadow-[inset_0_0_0_2px_rgb(107,114,128)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-500"
      >
        <GridIcon className="h-6 w-6" />
      </button>
      {gridStatus && (
        // eslint-disable-next-line max-len
        <div
          className="fixed inset-0 z-50 overflow-auto bg-white px-4 py-4 sm:absolute sm:bottom-auto sm:left-auto sm:right-[calc(100%_-_20px)] sm:top-[calc(100%_+_10px)] sm:max-h-[calc(100dvh-5rem)] sm:w-auto sm:rounded sm:border sm:border-gray-300 sm:px-6 sm:shadow-lg"
          role="dialog"
          aria-label="Modules"
        >
          <div className="mb-4 flex items-center justify-between sm:hidden">
            <h2 className="text-lg font-semibold text-gray-900">Modules</h2>
            <button
              type="button"
              onClick={() => changeGridStatus(false)}
              aria-label="Close modules"
              className="flex min-h-11 min-w-11 items-center justify-center rounded-md text-gray-600 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-500"
            >
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="grid w-full grid-cols-2 gap-3 sm:w-max sm:grid-cols-3 sm:gap-4">
            {permittedModules.map(item => (
              <Link
                key={item.name}
                className={`flex min-h-[7.5rem] w-full min-w-0 cursor-pointer flex-col items-center justify-center rounded-lg px-2 py-2 text-center transition-colors sm:min-h-0 sm:w-[90px] sm:min-w-[90px] sm:px-3 ${
                  isCurrentModule(item)
                    ? "bg-gray-100 text-gray-900 ring-1 ring-gray-300"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
                to={{ pathname: item.pathname }}
              >
                <item.icon aria-hidden="true" />
                <div className="mt-4 text-xs font-medium">{item.label}</div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SlideoutComponent;
